import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'gea-hrt-customer-has-no-machines',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
  template: `
    <div class="customer-has-no-machines">
      <h2>{{ 'BRC.CUSTOMER_HAS_NO_MACHINES' | translate }}</h2>
    </div>
  `,
  styles: `
    :host {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  `,
})
export class CustomerHasNoMachinesComponent {}
